<template>
  <v-card flat width="100%" height="100%" class="rounded-lg pa-4" v-if="barSeries[0].data.length > 0">
    <apexchart ref="barChart" height="100%" type="bar" :options="barOptions" :series="barSeries"/>
  </v-card>
</template>

<script>
export default {
  name: "visitCountChart",

  data: () => ({
    barOptions: {
      // colors: ['#A5E12D', '#5FBCBC'],
      colors: ['#02C182', '#08F1A1'],
      plotOptions: {
        bar: {
          borderRadius: 5,
          dataLabels: {
            position: 'top'
          }
        }
      },
      dataLabels: {
        enabled: true,
        offsetY: -20,
        style: {
          colors: ['#02C182']
        }
      },
      chart: {
        id: 'example-1',
      },
      yaxis: {
        labels: {
          show: false
        }
      },
      xaxis: {
        categories: [],
        position: 'top',
        labels: {
          rotate: 0,
          style: {
            fontSize: '14px',
            cssClass: 'apex-custom-label'
          }
        },
        axisBorder: {
          show: false
        },
        axisTicks: {
          show: false
        },
      },
    },
    barSeries: [{
      name: 'series-1',
      data: []
    }]
  }),

  methods: {
    updateData(obj) {
      let barChart = this.$refs.barChart

      if (obj) {
        if (barChart) {
          let chart = barChart.chart

          chart.updateOptions({
            xaxis: {
              categories: Object.keys(obj)
            }
          })
          chart.updateSeries([{
            data: Object.values(obj)
          }]);
        } else {
          this.barOptions.xaxis.categories = Object.keys(obj);
          this.barSeries[0].data = Object.values(obj);
        }
      }
    }
  }
}
</script>

<style scoped>

</style>